import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Badge, useLocalizeMessage } from 'libs.nucleus';
import { useDateTime } from 'libs.react';
import { getStatusBadgeVariant } from '../helpers/pi_oversight_list.helper';
export const usePIOversightListTableColumns = ({ onOpenPIOversightDetailsModal, }) => {
    const translate = useLocalizeMessage();
    const { parseDateShort } = useDateTime();
    const oversightTableColumns = useMemo(() => {
        return [
            {
                header: translate('label.participant_id'),
                accessorKey: 'participantId',
                cell: (context) => {
                    const row = context.row.original;
                    return (_jsx("div", { "data-row-status": row.status.toLowerCase().replace(' ', '-'), onClick: () => onOpenPIOversightDetailsModal(row.participantId), children: _jsx("p", { className: 'cursor-pointer underline text-primary-600', children: row.participantNumber }) }));
                },
            },
            {
                header: translate('label.pi_oversight.required_by_date'),
                accessorKey: 'dueAt',
                cell: (context) => {
                    const date = context.row.original.dueAt;
                    return _jsx("span", { children: parseDateShort(date) });
                },
            },
            {
                header: translate('label.pi_oversight.pi_review_status'),
                accessorKey: 'status',
                cell: (context) => {
                    const status = context.row.original.status;
                    const variant = getStatusBadgeVariant(status);
                    return _jsx(Badge, { variant: variant, label: status });
                },
            },
        ];
    }, [translate]);
    return oversightTableColumns;
};
